<script>
import SimpleTable from "@/view/order/extraFees/SimpleTable.vue";

export default {
  name: "ExtraFees",
  components: {SimpleTable},
  data() {
    return {
      activeTab: 'storageFees'
    }
  },
  methods: {
    // 接住 SimpleTable 抛出的按钮事件，按 action 分发业务逻辑
    // 注：创建杂费（create）与导出（exportAll/exportSelected）已由 SimpleTable 内部处理
    handleButtonClick(action, btn) {
      console.log(action, btn);
      switch (action) {
        default:
          break;
      }
    }
  }
}
</script>

<template>
<Card class="extra-fees-card">
  <Tabs :animated="false" v-model="activeTab" class="extra-fees-tabs">
    <TabPane name="storageFees" label="仓储费">
      <SimpleTable category="storageFees" @button-click="handleButtonClick" />
    </TabPane>
    <TabPane name="freightFees" label="派送费"></TabPane>
    <TabPane name="boxUsageFees" label="纸箱费"></TabPane>
    <TabPane name="changeLabelFees" label="贴标费"></TabPane>
  </Tabs>
</Card>
</template>

<style scoped>
/* 表格高度由 SimpleTable 依据视口自行计算，这里仅去掉多余的间距 */
::v-deep .extra-fees-card .ivu-card-body {
  padding: 0;
}
</style>
